import { errorPastilleClass } from "./sessionUtils";
import type { SessionErrorOption } from "./SessionErrorSelect";

interface SessionErrorBadgesProps {
  errors: SessionErrorOption[] | undefined | null;
  /** Optional extra classes for the wrapping flex container. */
  className?: string;
}

/**
 * Read-only render of a session's error pastilles. Used in the session detail
 * hero, the sessions list table, and the public share page.
 */
export function SessionErrorBadges({ errors, className }: SessionErrorBadgesProps) {
  if (!errors || errors.length === 0) return null;
  return (
    <div className={`flex flex-wrap gap-1 ${className ?? ""}`}>
      {errors.map((e) => (
        <span key={e.id} className={errorPastilleClass}>
          {e.name}
        </span>
      ))}
    </div>
  );
}
